// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d9-4";
export var closeButton = "_d9-6";
export var dismissButton = "_d9-3";
export var editImageWithAiContainer = "_d9-8";
export var imageUploadWrapper = "_d9-7";
export var misspelledWord = "_d9-5";
export var spellCheckContainer = "_d9-2";
export var spin = "_d9-1";
export var spinning = "_d9-0";